export default class OrderNotFoundError extends Error {
  constructor() {
    super('No encontramos una orden asociada a este correo electrónico. Verifica la dirección o intenta con otra.');
    this.name = 'OrderNotFoundError';
  }
}
